/* eslint-disable no-unused-vars */
import React from "react";
import { Button, FormTextInput } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const RequiredDocumentForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleChangeFormData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
  } = props;

  const [name, setName] = React.useState({
    value: initialValue.name ? initialValue.name : "",
    error: false,
    success: false,
  });

  const [description, setDescription] = React.useState({
    value: initialValue.description ? initialValue.description : "",
    error: false,
    success: false,
  });

  const handleChangeName = (value) => {
    setMessage(null);
    setName(value);
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleSaveData = () => {
    const formData = {
      name: name.value,
      description: description.value,
    };
    handleChangeFormData(formData);
  };

  const CreateTitle = Strings["RequiredDocument.CreateTitle"],
    EditTitle = Strings["RequiredDocument.EditTitle"],
    NameLabel = Strings["RequiredDocument.NameLabel"],
    NamePlaceholder = Strings["RequiredDocument.NamePlaceholder"],
    NameCustomError = Strings["RequiredDocument.NameCustomError"],
    DescriptionLabel = Strings["RequiredDocument.DescriptionLabel"],
    DescriptionPlaceholder = Strings["RequiredDocument.DescriptionPlaceholder"],
    DescriptionCustomError = Strings["RequiredDocument.DescriptionCustomError"],
    SaveBtn = Strings["RequiredDocument.SaveBtn"],
    UpdateBtn = Strings["RequiredDocument.UpdateBtn"],
    CancelBtn = Strings["RequiredDocument.CancelBtn"];

  let isValueChanged = name.value === initialValue.name;
  // description.value === initialValue.description;
  let disable =
    name.error ||
    // description.error ||
    name.value === "" ||
    // description.value === "" ||
    name.success === false ||
    // description.success === false;
    isValueChanged;

  //edit
  let isValueChangededit =
    name.value === initialValue.name &&
    description.value === initialValue.description;
  let disableEdit =
    name.error ||
    description.error ||
    name.value === "" ||
    description.value === "" ||
    (name.success === false && description.success === false) ||
    isValueChangededit;

  return (
    <div className="modalFormContainer">
      <h2>{actionType === "add" ? CreateTitle : EditTitle}</h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}
      <FormTextInput
        type="alpha"
        starProps={true}
        label={NameLabel}
        placeholder={NamePlaceholder}
        Value={name.value}
        onChangeText={handleChangeName}
        Validate={true}
        CustomErrorLine={NameCustomError}
        editable
        maxLength={30}
      />
      <FormTextInput
        type="text"
        label={DescriptionLabel}
        placeholder={DescriptionPlaceholder}
        Value={description.value}
        onChangeText={handleChangeDescription}
        // Validate={actionType === "add" ? false : true}
        Validate={false}
        CustomErrorLine={DescriptionCustomError}
        multiline={true}
        editable
        maxLength={50}
      />

      <div style={{ display: "flex", marginTop: "1.5rem" }}>
        <Button
          buttonName={actionType === "add" ? SaveBtn : UpdateBtn}
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={actionType === "add" ? disable : false}
          onClick={handleSaveData}
        />
        <Button
          buttonName={CancelBtn}
          onClick={() => {
            handleModalClose();
            setMessage(null);
          }}
          buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
        />
      </div>
    </div>
  );
};

export default RequiredDocumentForm;
